import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable, Field } from '../../commons/DataTable';
import ModalIafs from './ModalIafs';
import ModalAllIafs from './ModalAllIafs';

function ExtraInvoicesByMonthTable({
  data,
  query,
  onFilter,
  fetchIafsByMonthNetwork,
  total,
}) {
  const [t] = useTranslation('COMMON');

  return (
    <DataTable
      history
      data={data}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      offset={query.offset}
      limit={query.limit}
      onFilter={onFilter}
      total={total}
    >
      <Field
        className="txt-table-left"
        title="Amministratore"
        source="businessName"
      />
      <ModalIafs
        title="Gennaio"
        month={1}
        year={query.year}
        source="months[0]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Febbraio"
        month={2}
        year={query.year}
        source="months[1]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Marzo"
        month={3}
        year={query.year}
        source="months[2]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Aprile"
        month={4}
        year={query.year}
        source="months[3]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Maggio"
        month={5}
        year={query.year}
        source="months[4]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Giugno"
        month={6}
        year={query.year}
        source="months[5]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Luglio"
        month={7}
        year={query.year}
        source="months[6]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Agosto"
        month={8}
        year={query.year}
        source="months[7]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Settembre"
        month={9}
        year={query.year}
        source="months[8]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Ottobre"
        month={10}
        year={query.year}
        source="months[9]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Novembre"
        month={11}
        year={query.year}
        source="months[10]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalIafs
        title="Dicembre"
        month={12}
        year={query.year}
        source="months[11]"
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
      <ModalAllIafs
        year={query.year}
        fetchIafsByMonthNetwork={fetchIafsByMonthNetwork}
      />
    </DataTable>
  );
}

export default ExtraInvoicesByMonthTable;
